// extracted by mini-css-extract-plugin
export var card = "_s4-0";
export var details = "_s4-1";